import React from 'react'
import { Input, Icon } from 'antd'
import './ReferenceSearch.scss'

const ReferenceSearch = ({ value, onChange }) => {
  return (
    <div className="reference-search">
      <Input
        placeholder="Search references…"
        value={value}
        onChange={e => onChange(e.target.value)}
        prefix={<Icon type="search" style={{ color: '#9aa0a6', fontSize: 13 }} />}
        allowClear
        size="small"
      />
    </div>
  )
}

export default ReferenceSearch
